export default {
  fingerprint: (state) => state.fingerprint,
  webView: (state) => state.webView,
  mapOptions: (state) => state.mapOptions,
  appVersion: (state) => state.appVersion,
  clientType: (state) => state.clientType,
  account: (state) => state.account,
  status: (state) => state.status,
  offline: (state) => state.offline,
  available: (state) => state.available
}
